// Self-service account API (real-auth). Backend: PATCH /api/v1/auth/me updates
// the logged-in user's own display_name / locale. GET /auth/me + change-password
// already exist (lib/auth.ts + features/settings/Security.tsx).

import { apiUrl } from '../lib/api'
import type { AppearancePreference } from '../lib/appearance'

export type SelfProfile = {
  id: string
  email: string
  display_name: string
  phone: string | null
  locale: string | null
  appearance_preference?: AppearancePreference
}

export async function updateProfile(body: {
  display_name?: string
  phone?: string
  locale?: string
  appearance_preference?: AppearancePreference
}): Promise<SelfProfile> {
  const res = await fetch(apiUrl('/auth/me'), {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) {
    const data = (await res.json().catch(() => null)) as
      | { detail?: { message?: string } }
      | null
    throw new Error(data?.detail?.message ?? `update failed: ${res.status}`)
  }
  return res.json() as Promise<SelfProfile>
}
